const state = {
  allSelectMap: {},
}

const mutations = {
  SET_MAP(states, selectMap) {
    states.allSelectMap = selectMap
  },
  SET_MAP_CATEGORY(states, category) {
    states.allSelectMap.leadCategoryList = category.leadCategoryList
    states.allSelectMap.leadCategoryListTree = category.leadCategoryListTree
  },
}

const actions = {
  setMap({ commit }, selectMap) {
    commit('SET_MAP', selectMap)
  },
  setMapCategory({ commit }, selectMap) {
    commit('SET_MAP_CATEGORY', selectMap)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
